import { useUiStore } from '../../stores/ui.store';

export default function OfflineBanner() {
  const offline = useUiStore((s) => s.offline);

  if (!offline) return null;

  return (
    <div className="offline-banner" role="alert">
      <span className="offline-banner__icon">📴</span>
      <span className="offline-banner__text">
        You are in <strong>offline mode</strong>. Transactions will be queued and synced when reconnected.
      </span>
    </div>
  );
}
